export default __webpack_public_path__ + "static/media/cardboard_study_3.bf15ac15.jpg";